module.exports = __webpack_public_path__ + "components/home-header/static/header-3--medium@2x-ec48d03ca6158c5b37bba016ea6a8a12.jpg";